import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';
import { graphql, useStaticQuery } from 'gatsby';
import { useEffect } from 'react';
import Button from '../../atoms/button/button';
import './errorModal.scss';

interface ErrorModalInterface {
    closeModal: () => void;
    isMobile?: boolean;
    buttonEvent?: () => void;
    buttonCopy?: string;
    title?: string;
    subtitle?: any;
    extraEvent?: () => void | Promise<void>;
    extraEventCopy?: string;
    imageNew?: any;
}

const ErrorModal = (props: ErrorModalInterface) => {
    const data = useStaticQuery(graphql`
        query GET_MODAL_LO_SENTIMOS_DATA {
            allContentfulTemplate(
                filter: {
                    titulo: { eq: "Modal Portal > ¡Ups! Algo salió mal" }
                }
            ) {
                nodes {
                    imagen {
                        title
                        file {
                            url
                        }
                        gatsbyImageData(
                            formats: [AUTO, WEBP]
                            placeholder: BLURRED
                        )
                    }
                    nombre
                    descripcion {
                        raw
                    }
                    referencias {
                        ... on ContentfulTemplate {
                            copyBoton
                            redireccion
                        }
                    }
                }
            }
        }
    `);

    const contentData = data.allContentfulTemplate.nodes[0];
    const { imagen, nombre, referencias, descripcion } = contentData ?? {};

    useEffect(() => {
        document.documentElement.style.overflowY = 'hidden';
        return () => {
            document.documentElement.style.overflowY = 'scroll';
        };
    }, []);

    const setModalClose = () => {
        props.closeModal();
    };

    const setValueClose = () => {
        setModalClose();
    };

    const setOptions = (className: string) => {
        return {
            renderNode: {
                [BLOCKS.PARAGRAPH]: (_node: any, children: any) => (
                    <p className={className}>{children}</p>
                ),
            },
        };
    };

    return (
        <div role="dialog" className={'m-error-modal'}>
            <div className="m-error-modal__content" onClick={() => {}}>
                <div className="m-error-modal__exit">
                    <button
                        aria-label="Close"
                        className="icon icon-close m-error-modal__exit-icon"
                        onClick={setModalClose}
                    />
                </div>
                <div className="m-error-modal__container">
                    {(contentData?.imagen || props.imageNew) && (
                        <img
                            className="m-error-modal__container-icon"
                            src={
                                props.imageNew
                                    ? props.imageNew
                                    : imagen[0].file.url
                            }
                            alt={
                                props.imageNew
                                    ? props.imageNew.title
                                    : imagen[0].title
                            }
                            title={
                                props.imageNew
                                    ? props.imageNew.title
                                    : imagen[0].title
                            }
                        />
                    )}
                    {(nombre || props.title) && (
                        <h3 className="m-error-modal__container-title">
                            {props.title ? props.title : nombre}
                        </h3>
                    )}
                    {((descripcion && descripcion.raw) || props.subtitle) &&
                    props.subtitle ? (
                        props.subtitle.raw ? (
                            documentToReactComponents(
                                JSON.parse(props.subtitle.raw),
                                setOptions(
                                    'm-error-modal__container-description'
                                )
                            )
                        ) : (
                            <p className="m-error-modal__container-description">
                                {props.subtitle}
                            </p>
                        )
                    ) : (
                        documentToReactComponents(
                            JSON.parse(descripcion.raw),
                            setOptions('m-error-modal__container-description')
                        )
                    )}
                    <Button
                        type="button"
                        classname="m-error-modal__container-button modal"
                        text={
                            props.buttonCopy
                                ? props.buttonCopy
                                : referencias[0].copyBoton
                                ? referencias[0].copyBoton
                                : 'Aceptar'
                        }
                        isDisabled={false}
                        onClickAction={
                            props.buttonEvent
                                ? props.buttonEvent
                                : setValueClose
                        }
                    />
                    {props.extraEvent && props.extraEventCopy && (
                        <>
                            <div className="m-error-modal__container-separator"></div>
                            <p
                                className="m-error-modal__container-extra-event"
                                onClick={props.extraEvent}
                            >
                                {props.extraEventCopy}
                            </p>
                        </>
                    )}
                </div>
            </div>
            <button
                role="button"
                aria-label="Close"
                className="m-error-modal__bkg"
                onClick={setModalClose}
            ></button>
        </div>
    );
};

export default ErrorModal;
